import EcoendoscopiaEdit from "./components/EcoendoscopiaEdit.vue"
import EcoendoscopiaView from "./components/EcoendoscopiaView.vue"
import EcoendoscopiaList from "./components/EcoendoscopiaList.vue"


export default{
    EcoendoscopiaList,
    EcoendoscopiaView,
    EcoendoscopiaEdit
}